import { render, staticRenderFns } from "./ContainerList.vue?vue&type=template&id=06ddc841&scoped=true&"
import script from "./ContainerList.vue?vue&type=script&lang=js&"
export * from "./ContainerList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "06ddc841",
  null
  
)

export default component.exports